<template>
  <div>
      <router-link
        class="btn btn-success-header header-item"
        exact
        to="/contacts"
    >Contacts</router-link>

    <router-link
        class="btn btn-success-header header-item"
        exact
        to="/orders"
    >Orders</router-link>
    <router-link
        class="btn btn-success-header header-item"
        exact
        to="/inventory"
    >Inventory</router-link>
    <router-link
        class="btn btn-success-header header-item"
        exact
        to="/form"
    >Digital Signature Form</router-link>

    <router-link
        class="btn btn-success-header header-item"
        exact
        to="/sky_simulator"
    >Sky Simulator</router-link>

  </div>
</template>

<script>
import UsersPermissionCheck from "@/mixins/user/auth/UsersPermissionCheck";

export default {
name: "Projects.container",
  mixins: [UsersPermissionCheck],

}
</script>

<style scoped>

</style>